import { render } from "./CustomWidget.vue?vue&type=template&id=7a947104&scoped=true"
import script from "./CustomWidget.vue?vue&type=script&lang=js"
export * from "./CustomWidget.vue?vue&type=script&lang=js"

import "./CustomWidget.vue?vue&type=style&index=0&id=7a947104&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a947104"]])

export default __exports__